var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlockOpsIcon2048(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    role: "img",
    width: 2048,
    height: 2048,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 34.6875L24 42L32 37.5L37 34.6875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 30V15L27.5 7.96875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 7.96875L8 15V30"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F88FF",
    d: "M21 18.75L18 20.5V24V27.5L21 29.25L24 31L27 29.25L30 27.5V24V20.5L27 18.75L24 17L21 18.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 17V10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 27L37 31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 27L11 31"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 7,
    r: 3,
    fill: "#2F88FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 33,
    r: 3,
    fill: "#2F88FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 33,
    r: 3,
    fill: "#2F88FF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockOpsIcon2048);
export default __webpack_public_path__ + "static/media/block-ops-icon-2048.a4ca73df1e304f2bc94275c2957970b6.svg";
export { ForwardRef as ReactComponent };